import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import './Header.css';
import axios from 'axios';
import Cookies from 'js-cookie';
import { Container, Nav, Navbar, Modal, Form, Button, NavDropdown } from 'react-bootstrap';
import logoWhite from './img/Livetopic-1.webp';
import logoDark from './img/Livetopic.svg';
import close from './img/close-popup.svg';
import avatar from './img/Avatar.png';
import sun from './img/sun.png';
import europa from './img/normal-reproduction-high-resolution.jpg'
import reacciona from './img/Cartel_Empresas-2022_.jpeg'


class Header extends Component {

  constructor (props) {
    super(props);
    let url = window.location.href;
    let lang;
    if (url.search('/en') !== -1) {
      lang = 'en';
    } else {
      lang = 'es';
    }
    var listaPalabras = JSON.stringify(require('../../translate/' + lang + '.json'));
    var wordList = JSON.parse(listaPalabras);
    if (lang == 'es') {
      lang = '';
    } else {
      lang = lang + '/';
    }
    this.state = {
      lang: lang,
      wordList: wordList.app,
      wordListUrl: wordList.url,
      height: 'auto',
      show: false,
      session: 0,
      background: 'transparent',
      iconNavbar: '/img/open-menu.png',
      iconNavbarColor: '/img/open-menu-color.png',
      name: '',
      message: 'hide',
      messageError: 'hide',
      messageText: '',
      typeIcon : 0
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.logOut = this.logOut.bind(this);
    this.contact = this.contact.bind(this);
  }

  logOut () {
    // CERRAR SESIÖN
    Cookies.remove('user');
    window.location.reload();
  }

  handleClose () {
    // CIERRA MODAL
    this.setState(prevState => ({
      show: !prevState.show
    }));
  }

  handleShow () {
    // ABRE MODAL
    this.setState(prevState => ({
      show: !prevState.show
    }));

    // COMPROBAMOS SI EXISTE COOKIE CON DATOS DEL CLIENTE Y LOS INSERTAMOS EN LA MODAL
    var dataUser = Cookies.get('dataUser');
    if (dataUser != undefined) {
      dataUser = JSON.parse(dataUser);
      setTimeout(function () {
        if (dataUser.contact_profile.email != '') {
          document.getElementById('emailModal').value = dataUser.contact_profile.email;
        }
        if (dataUser.contact_profile.firstname != '') {
          document.getElementById('firstnameModal').value = dataUser.contact_profile.firstname;
        }
        if (dataUser.contact_profile.mobile_phone != '') {
          document.getElementById('mobilePhoneModal').value = dataUser.contact_profile.mobile_phone;
        }
      }.bind(this), 300);
    }

  }

  contact () {

    var dataUser = Cookies.get('dataUser');
    if (dataUser != undefined) {
      dataUser = JSON.parse(dataUser);
      var id = parseInt(dataUser.contact_profile.id);
    } else {
      id = 0;
    }
    var firstname = document.getElementById('firstnameModal').value;
    var email = document.getElementById('emailModal').value;
    var mobile_phone = document.getElementById('mobilePhoneModal').value;
    mobile_phone = mobile_phone.replace(/ /g, '');

    if (firstname != '' && mobile_phone.toString().length == 9 && email.includes('@')) {
      var today = new Date();
      var month = today.getMonth() + 1;
      if (month <= 9) {
        month = '0' + month;
      }
      var day = today.getDate();
      if (day <= 9) {
        day = '0' + today.getDate();
      }
      var date = today.getFullYear() + '-' + month + '-' + day;
      var object = {
        'current_customer': false,
        'id': id,
        'date': date,
        'email': email,
        'name': firstname,
        'mobile_phone': mobile_phone,
        'kind': 'information',
        'subject': firstname + ' quiere que le llamen',
        'description': 'El usuario hizo click en \'¿Tienes dudas?\' en el proceso de rellenar datos en el formulario.'
      };

      // AL MOMENTO DE COLOCAR ESTE SERVICIO NO FUNCIONABA, EN TEORÍA HACE UNA NUEVA CONSULTA Y LOS DATOS DEBEN ACTUALIZARSE AUTOMÁTICAMENTE
      
      axios.post(process.env.REACT_APP_API_URL + '/notifications/websiteForm', object,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(res => {
        var resData = res.data; 
        if (resData.status == 'ok') {
          this.setState({
            message: 'show',
            messageText: this.state.wordList.todoOk
          });
        } else {
          this.setState({
            messageError: 'show',
            messageText: this.state.wordList.errorDatos
          });
          setTimeout(function () {
            this.setState({
              message: 'hide',
              messageError: 'hide'
            });
          }.bind(this), 3000);
        }
      }).catch(error => {
        this.props.history.push('/' + this.state.lang + '' + this.state.wordListUrl.page404);
        //console.log(error);
        if (!error.response) {
          //console.log(error.response);
        } else {
          //console.log(error.response);
        }
      });
    } else {
      this.setState({
        messageError: 'show',
        messageText: this.state.wordList.error
      });

      setTimeout(function () {
        this.setState({
          messageError: 'hide'
        });
      }.bind(this), 3000);
    }

  }

  componentDidMount () {
    if(this.props.type=="light") {
      this.setState({
        typeIcon: 1
      });
    } else {
      this.setState({
        typeIcon: 0
      });
    }
    // CAMBIA EL COLOR DEL FONDO DEL MENU CUANDO ABRES O CIERRAS EL MENU
    setTimeout(function () {
      if(this.state.typeIcon==0) {
        if (document.getElementsByClassName('navbar-toggler')[0]) {
          document.getElementsByClassName('navbar-toggler')[0].addEventListener('click', function () {
            if (this.state.background == 'transparent') {
              this.setState({
                background: 'radial-gradient(circle, rgba(105,53,167,1) 0%, rgba(59,0,130,1) 100%)',
                height: '100vh',
                iconNavbar: '/img/close-menu.png'
              });
            } else {
              setTimeout(function () {
                this.setState({
                  background: 'transparent',
                  height: 'auto',
                  iconNavbar: '/img/open-menu.png'
                });
              }.bind(this), 300);
            }
          }.bind(this));
        }
      } else {
        if (document.getElementsByClassName('navbar-toggler')[0]) {
          document.getElementsByClassName('navbar-toggler')[0].addEventListener('click', function () {
            if (this.state.background == 'transparent') {
              this.setState({
                background: 'radial-gradient(circle, rgba(105,53,167,1) 0%, rgba(59,0,130,1) 100%)',
                height: '100vh',
                iconNavbarColor: '/img/close-menu-color.png'
              });
            } else {
              setTimeout(function () {
                this.setState({
                  background: 'transparent',
                  height: 'auto',
                  iconNavbarColor: '/img/open-menu-color.png'
                });
              }.bind(this), 300);
            }
          }.bind(this));
        }
      }

    }.bind(this), 800);

    // COMPROBAMOS SI EL USUARIO INICIO SESIÓN
    var user = Cookies.get('user');
    if (user != undefined) {
      user = JSON.parse(user);
      this.setState({
        session: 1,
        name: user[0].holder.firstname
      });
    } else {
      this.setState({
        session: 0
      });
    }

  }

  render () {
    const {type} = this.props; 
    
    if (type == 'dark') {

      const {wordList, lang, show, wordListUrl, background, height, iconNavbar, session, name, typeIcon} = this.state;
       
      return (
        <div>
          <div className="menu-home-dark">
            <Container style={{background: background.toString(), height: height.toString()}}>
              <Navbar collapseOnSelect expand="lg">
                <Navbar.Brand><Link to={'/' + lang}><img src={logoWhite} style={{width: '140px'}} alt={wordList.logo}/></Link></Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav"><img src={iconNavbar} className="menu-toggle"
                                                                          alt="menu"/></Navbar.Toggle>
                <Navbar.Collapse id="responsive-navbar-nav">

                  <Nav className="mr-auto menu-collapsed">
                    <Link to={'/' + this.state.lang}
                          className="link-home nav-link nav-top font-l margin-left-xl">{wordList.inicio} </Link>
                    <Link to={'/' + this.state.lang + '' + wordListUrl.product} id="menu-1"
                          className="nav-link nav-top font-l margin-left-xl">{wordList.producto}<span><hr id="bar-1"
                                                                                                          className="bar1 hide-visibility"/></span></Link>
                    <Link to={'/' + this.state.lang + '' + wordListUrl.howWork} id="menu-2"
                          className="nav-link nav-top  font-l margin-left-l">{wordList.comoFunciona}<span><hr id="bar-2"
                                                                                                              className="bar2 hide-visibility"/></span></Link>
                    <Link to={'/' + this.state.lang + '' + wordListUrl.faqs} id="menu-3"
                          className="nav-link nav-top font-l margin-left-l">{wordList.preguntas}<span><hr id="bar-3"
                                                                                                          className="bar3 hide-visibility"/></span></Link>
                    <Link to={'/' + this.state.lang + '' + wordListUrl.about} id="menu-5"
                          className="nav-link nav-top font-l margin-left-l">{wordList.nosotros}<span><hr id="bar-5"
                                                                                                          className="bar5 hide-visibility"/></span></Link>

                    <a href="https://blog.livetopic.es/"  className="nav-link nav-top font-l margin-left-l" target="_blank">Consejos</a>
                    
                    <Navbar.Collapse  style={{marginTop:"-8px"}}>
                      <Nav >
                        <NavDropdown
                          id="LivetopicLabs"
                          title="Livetopic Tech"
                          menuVariant="dark"
                          style={{fontSize: '19px', maxHeight:'300px', verticalAlign:"Top"}}
                        >
                          <NavDropdown.Item href="http://desarrollo.livetopic.es:3000/">Tu recomendación inteligente</NavDropdown.Item>
                          <NavDropdown.Item href="http://desarrollo.livetopic.es:3130/">Tu seguro en la blockchain</NavDropdown.Item>
                          
                        </NavDropdown>
                      </Nav>
                    </Navbar.Collapse>
                    
                    
                  </Nav>
                  <Nav>
                
                   <Nav className="europe"> 
                    <div onClick={this.handleShow} className="nav-link font-l white"> 
                        <img src={europa} width="75" heigh="75" alt="EUROPA"/>
                    </div>
                    </Nav>
                    <Nav className="navbar-nav login"> <a href={'/'+this.state.lang+'#calculator-form'}
                                                             className="nav-link rounded font-l size-right">{wordList.asegurar}</a></Nav>
                                                            
                    { /* ELIMINAR ESTA LINEA DE ABAJO Y DESCOMENTAR LO DE ABAJO PARA HABILITAR ACCESO */}
                    <Nav className="navbar-nav without-icon">
                      <div id="menu-4" className="nav-top-left nav-link font-l white margin-left-l size-right">
                        <hr id="bar-4" className="bar4 hide-visibility"/>
                      </div>
                    </Nav>
                    { /*
                      {session==0 && <Nav className="navbar-nav without-icon"><Link to={'/'+this.state.lang+""+wordListUrl.access} id="menu-4" className="nav-top-left nav-link font-l white margin-left-l size-right">{wordList.acceder}<span><hr id="bar-4" className="bar4 hide-visibility"/></span></Link></Nav> }
                      {session==1 && <Nav>  
                      <NavDropdown title={
                      <span>
                          <img className="avatar" 
                              src={avatar} 
                              alt="user pic"
                              height={50}
                              width={50} 
                          />
                          <span className="name">{name}</span>
                      </span> } id="basic-nav-dropdown">
                      <Link to={'/'+this.state.lang+""+wordListUrl.profile}><NavDropdown.Item href="#action/3.1">Configurar mi perfil</NavDropdown.Item></Link>
                        <NavDropdown.Item className="close-sesion" onClick={this.logOut}>Cerrar sesión</NavDropdown.Item> 
                      </NavDropdown>
                      </Nav> 
                      }
                      {session==0 && <Nav className="navbar-nav with-icon"><Link to={'/'+this.state.lang+""+wordListUrl.access} className="nav-top-left nav-link font-l white margin-left-l size-right"><img src={iconPerson} alt="icon" style={{paddingRight:"10px"}}/> {wordList.accederIcono}</Link></Nav>
                      }*/}
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
            </Container>
          </div>

          <Modal show={show}  size="xl" className="modal-popup reacciona"  onHide={this.handleClose}>
            <Modal.Header closeButton/>
            <Modal.Body > <img src={reacciona} width="700" heigh="700" alt="REACCIONA"/></Modal.Body>
          </Modal>
        </div>
      );
    } else if (type == 'light') {
      const {wordList, lang, wordListUrl, background, height, iconNavbarColor, session, name, typeIcon} = this.state;
       
      return (
        <div>
          <div className="menu-home">
            <Container style={{background: background.toString(), height: height.toString()}}>
              <Navbar collapseOnSelect expand="lg">
                <Navbar.Brand><Link to={'/' + lang}><img src={logoDark} style={{width: '140px'}}
                                                         alt={wordList.logo}/></Link></Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav"><img src={iconNavbarColor} className="menu-toggle"
                                                                          alt="menu"/></Navbar.Toggle>
                <Navbar.Collapse id="responsive-navbar-nav">

                  <Nav className="mr-auto menu-collapsed">
                    <Link to={'/' + this.state.lang}
                          className="link-home nav-link nav-top font-l margin-left-xl">{wordList.inicio} </Link>
                    <Link to={'/' + this.state.lang + '' + wordListUrl.product} id="menu-1"
                          className="nav-link nav-top font-l margin-left-xl">{wordList.producto}<span><hr id="bar-1"
                                                                                                          className="bar1 hide-visibility"/></span></Link>
                    <Link to={'/' + this.state.lang + '' + wordListUrl.howWork} id="menu-2"
                          className="nav-link nav-top  font-l margin-left-l">{wordList.comoFunciona}<span><hr id="bar-2"
                                                                                                              className="bar2 hide-visibility"/></span></Link>
                    <Link to={'/' + this.state.lang + '' + wordListUrl.faqs} id="menu-3"
                          className="nav-link nav-top font-l margin-left-l">{wordList.preguntas}<span><hr id="bar-3"
                                                                                                          className="bar3 hide-visibility"/></span></Link>
                                                                                                          
                    <Link to={'/' + this.state.lang + '' + wordListUrl.about} id="menu-5"
                          className="nav-link nav-top font-l margin-left-l">{wordList.nosotros}<span><hr id="bar-5"
                                                                                                          className="bar5 hide-visibility"/></span></Link>
                                                                                                          
                    <a href="https://blog.livetopic.es/"  className="nav-link nav-top font-l margin-left-l" target="_blank">Consejos</a>

                   
                    
                  </Nav>
                  <Nav>
                    <Nav className="navbar-nav login"> <a href={'/'+this.state.lang+'#calculator-form'}
                                                             className="nav-link rounded font-l size-right">{wordList.asegurar}</a></Nav>
                    { /* ELIMINAR ESTA LINEA DE ABAJO Y DESCOMENTAR LO DE ABAJO PARA HABILITAR ACCESO */}
                    <Nav className="navbar-nav without-icon">
                      <div id="menu-4" className="nav-top-left nav-link font-l white margin-left-l size-right">
                        <hr id="bar-4" className="bar4 hide-visibility"/>
                      </div>
                    </Nav>
                    { /*
                      {session==0 && <Nav className="navbar-nav without-icon"><Link to={'/'+this.state.lang+""+wordListUrl.access} id="menu-4" className="nav-top-left nav-link font-l white margin-left-l size-right">{wordList.acceder}<span><hr id="bar-4" className="bar4 hide-visibility"/></span></Link></Nav> }
                      {session==1 && <Nav>  
                      <NavDropdown title={
                      <span>
                          <img className="avatar" 
                              src={avatar} 
                              alt="user pic"
                              height={50}
                              width={50} 
                          />
                          <span className="name">{name}</span>
                      </span> } id="basic-nav-dropdown">
                      <Link to={'/'+this.state.lang+""+wordListUrl.profile}><NavDropdown.Item href="#action/3.1">Configurar mi perfil</NavDropdown.Item></Link>
                        <NavDropdown.Item className="close-sesion" onClick={this.logOut}>Cerrar sesión</NavDropdown.Item> 
                      </NavDropdown>
                      </Nav> 
                      }
                      {session==0 && <Nav className="navbar-nav with-icon"><Link to={'/'+this.state.lang+""+wordListUrl.access} className="nav-top-left nav-link font-l white margin-left-l size-right"><img src={iconPerson} alt="icon" style={{paddingRight:"10px"}}/> {wordList.accederIcono}</Link></Nav>
                      } */}
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
            </Container>
          </div>
        </div>
      );
    } else if (type == 'recommender') {
      const {wordList, lang, background, show, height, iconNavbar, message, messageText, messageError, typeIcon} = this.state;
       
      return (
        <div>
          <div className="menu">
            <Container style={{background: background.toString(), height: height.toString()}}>
              <Navbar collapseOnSelect expand="lg">
                <Navbar.Brand><Link to={'/' + lang}><img src={logoWhite} style={{width: '140px'}}/>
                </Link></Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav"><img src={iconNavbar} className="menu-toggle"
                                                                          alt="menu"/></Navbar.Toggle>
                <Navbar.Collapse id="responsive-navbar-nav">
                  <Nav className="mr-auto menu-collapsed">
                  </Nav>
                  <Nav>
                    <Nav className="navbar-nav-menu">
                      <div onClick={this.handleShow} className="nav-link font-l white">{wordList.dudas}</div>
                    </Nav>
                    <Nav className="navbar-nav-menu"> <a href={'mailto:' + wordList.emailHeader} target="_blank"
                                                         className="nav-link rounded font-l margin-left-l">{wordList.emailHeader}</a></Nav>
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
            </Container>
          </div>


          <Modal show={show} size="lg" className="modal-popup" onHide={this.handleClose}
                 aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className="close-modal" onClick={this.handleClose}>
              <img src={close} className="icon-size-left"/>
            </Modal.Header>
            <Modal.Body>
              <h2 className="title-modal">{wordList.titleModalAyuda}</h2>
              <p className="sub-title-modal">{wordList.subTitleModalAyuda}</p>
              <div className="form-number">
                <Form.Control type="text" placeholder={wordList.nombre} id="firstnameModal"/>
              </div>
              <div className="form-number">
                <Form.Control type="number" placeholder={wordList.telefono} id="mobilePhoneModal"/>
              </div>
              <div className="form-number">
                <Form.Control type="email" placeholder={wordList.emailPopup} id="emailModal"/>
              </div>
              <div className={'messageModal ' + message}>{messageText}</div>
              <div className={'messageError ' + messageError}>{messageText}</div>
              <div style={{textAlign: 'center'}}>
                <Button size="lg" className="bottom-call-popup"
                        onClick={this.contact}>{wordList.botonLlamadme} </Button>
              </div>

            </Modal.Body>
          </Modal>
        </div>
      );
    } else if (type == 'profile') {
      const {wordList, lang, wordListUrl, background, height, iconNavbar, name, typeIcon} = this.state;
       
      return (
        <div>
          <img src={sun} alt="sun" className="sun-header"/>
          <div className="menu-home-profile">
            <Container style={{background: background.toString(), height: height.toString()}}>
              <Navbar collapseOnSelect expand="lg">
                <Navbar.Brand><Link to={'/' + lang}><img src={logoWhite} style={{width: '140px'}} alt={wordList.logo}/></Link>
                  <span className="near-brand">Área de clientes</span></Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav"><img src={iconNavbar} className="menu-toggle"
                                                                          alt="menu"/></Navbar.Toggle>
                <Navbar.Collapse id="responsive-navbar-nav">

                  <Nav className="mr-auto menu-collapsed">
                    <Link to={'/' + this.state.lang}
                          className="link-home nav-link nav-top font-l margin-left-xl">{wordList.inicio} </Link>
                    <Link to={'/' + this.state.lang + '' + wordListUrl.profileMyProduct} id="menu-1"
                          className="nav-link nav-top font-l margin-left-xl">Productos contratados<span><hr id="bar-1"
                                                                                                            className="bar1 hide-visibility"/></span></Link>
                    <Link to={'/' + this.state.lang + '' + wordListUrl.profileQuestions} id="menu-2"
                          className="nav-link nav-top  font-l margin-left-l">Preguntas<span><hr id="bar-2"
                                                                                                className="bar2 hide-visibility"/></span></Link>
                    <Link to={'/' + this.state.lang + '' + wordListUrl.profileHelp} id="menu-3"
                          className="nav-link nav-top font-l margin-left-l">Ayuda<span><hr id="bar-3"
                                                                                           className="bar3 hide-visibility"/></span></Link>
                    <Link to={'/' + this.state.lang + '' + wordListUrl.profileNotify} id="menu-4"
                          className="nav-link nav-top font-l margin-left-l"><span
                      className="separator">|</span> Notificar Siniestro<span><hr id="bar-4"
                                                                                  className="bar4 hide-visibility"/></span></Link>

              
                  </Nav>
                 

                </Navbar.Collapse>
              </Navbar>
            </Container>
          </div>
        </div>
      );
    }
  }
};

export default withRouter(Header);
